// extracted by mini-css-extract-plugin
export default {"payment-result":"PayBill_payment-result__iKTOI","form-field-amount":"PayBill_form-field-amount__irgra","payment-result-button":"PayBill_payment-result-button__iKRfc"};